module.exports = __webpack_public_path__ + "img/pnb-metlife-logo.4e82de12.jpg";